module.exports = __webpack_public_path__ + "static/media/epin_network.cbe58f88.png";